import { render, staticRenderFns } from "./ClassMetricRenderer.vue?vue&type=template&id=576b4b9d&lang=pug&"
import script from "./ClassMetricRenderer.vue?vue&type=script&lang=ts&"
export * from "./ClassMetricRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports